module.exports = __webpack_public_path__ + "static/media/slots.5f0bb53e.svg";